import { useState } from 'react';
import { MessageSquare, Settings, BarChart2, Cpu, LogOut, Filter, Users } from 'lucide-react';
import Avatar from '../ui/Avatar';
import { HUMANS } from '../../data/humans';

export default function Sidebar({ activeTab, setActiveTab, currentUser, onSwitchUser, onLogout, users = HUMANS }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const NavButton = ({ id, icon: Icon }) => (
    <button 
      onClick={() => setActiveTab(id)} 
      className={`p-3 rounded-xl transition-all duration-200 ${activeTab === id ? 'bg-appPrimary text-white shadow-lg' : 'text-appTextMuted hover:bg-appSurfaceBorder/30 hover:text-appText'}`}
      aria-label={id}
      type="button"
    >
      <Icon size={20} />
    </button>
  );

  return (
    <div className="w-[72px] bg-appSurface border-r border-appSurfaceBorder flex flex-col items-center py-6 gap-6 shrink-0 h-full z-20">
      <div className="relative">
        <button type="button" onClick={() => setMenuOpen(!menuOpen)} className="hover:scale-105 transition-transform active:scale-95">
          <Avatar label={currentUser.avatar} color="bg-appPrimaryLight text-appPrimaryText" />
        </button>
        {menuOpen && (
          <div className="absolute top-0 left-14 w-56 bg-appSurface rounded-2xl shadow-2xl border border-appSurfaceBorder p-2 z-[100] animate-in slide-in-from-left-2 duration-200">
            <p className="px-3 py-2 text-[10px] font-bold text-appTextMuted uppercase tracking-widest border-b border-appSurfaceBorder mb-1">Mudar Perfil</p>
            {users.map(agent => (
              <button key={agent.id} type="button" onClick={() => { onSwitchUser(agent); setMenuOpen(false); }} className="w-full text-left px-3 py-2.5 rounded-xl text-sm hover:bg-appSurfaceBorder/30 text-appText font-medium flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-appPrimary" />
                {agent.name}
              </button>
            ))}
            {onLogout && (
              <button type="button" onClick={() => { onLogout(); setMenuOpen(false); }} className="w-full text-left px-3 py-2.5 rounded-xl text-sm hover:bg-red-50 text-red-600 font-medium flex items-center gap-3 mt-1 border-t border-appSurfaceBorder">
                <LogOut size={16} />
                Sair
              </button>
            )}
          </div>
        )}
      </div>

      <div className="flex flex-col gap-3">
        <NavButton id="inbox" icon={MessageSquare} />
        <NavButton id="contacts" icon={Users} />
        <NavButton id="funnel" icon={Filter} />
        <NavButton id="ai_config" icon={Cpu} />
        <NavButton id="analytics" icon={BarChart2} />
      </div>

      <div className="mt-auto flex flex-col gap-3">
        <NavButton id="settings" icon={Settings} />
      </div>
    </div>
  );
}
